import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { setlocal } from '@src/utils/index';
import { area } from '@src/utils/area';

const Success = ({ updateId, languages }) => {
    const tipText = updateId ? area[languages].success.title2 : area[languages].success.title1;

    useEffect(() => {
        setlocal('areaimg1FormBase64Url', null);
        setlocal('areaimg2FormBase64Url', null);
        setlocal('areaimg3FormBase64Url', null);
        setlocal('areaformData', null);
        // setlocal('submitSucess', 1);

        setTimeout(() => {
            location.href = location.href.includes('from_wecom=1') ? location.href : `${location.href}?from_wecom=1`;
        }, 5000);
    }, []);

    return (
        <div className={styles.success}>
            <div className={styles.successBox} dangerouslySetInnerHTML={{ __html: tipText }} />
            <div className={styles.successCallback}>{area[languages].success.info}：wangning11@ifeng.com</div>
        </div>
    );
};

Success.propTypes = {
    updateId: PropTypes.string,
    languages: PropTypes.string,
};

export default errorBoundary(Success);
